import { useParams } from 'react-router-dom';
import ScreenForm from './components/ScreenForm';
import { useMediaQuery } from 'react-responsive';
import NewScreenMobile from '../Create/NewScreenMobile';

const ScreenDetailPage = () => {
  const { id } = useParams();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  if (isMobile) {
    return <NewScreenMobile screenId={id} />;
  }

  return <ScreenForm screenId={id} />;
};

export default ScreenDetailPage;

